import { Dispatch } from 'redux';
import { TGetRootState, TDispatchResult } from 'types/shared';

import {
  saveUserSettings,
  IUserSettingsState,
  IUserSettingsAction,
} from '../userSettings';

export const SET_USER_DIVISION = 'opus/user/user_division/SET_USER_DIVISION';

export default function reducer(
  state: IUserSettingsState,
  action: IUserSettingsAction
): IUserSettingsState {
  switch (action.type) {
    case SET_USER_DIVISION: {
      return action?.payload;
    }
    default:
      return state;
  }
}

export const saveUserDivision = (division: string): TDispatchResult<any> => {
  return function (dispatch: Dispatch, getState: TGetRootState): any {
    dispatch({
      type: SET_USER_DIVISION,
      payload: division,
    });

    // If getState().userSettings.success.all is false, this means we encountered an error while loading the
    // userSettings endpoint. It's safest not to overwrite this with the current Redux store anymore.
    if (getState().userSettings.success.all) {
      return dispatch(saveUserSettings('userDivision') as any);
    }
    // eslint-disable-next-line no-console
    console.warn(
      'We are not saving a parameter userDivision to the KV store because we could not retrieve them and do not want to run the risk of corrupting data.'
    );
  };
};
